import { IonicModule } from '@ionic/angular';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalHelpComponent } from './modal-help.component';



@NgModule({
    declarations: [ModalHelpComponent],
    imports: [
        CommonModule,
        IonicModule
    ]
})
export class ModalHelpModule { }
